import type { PropsWithChildren } from 'react'
import { Children, isValidElement } from 'react'

import { Space } from '@procurify/ui'
import { noop } from 'lodash'

import { Tab } from '@webapp/core/components/Tabs/Tab'
import { type ITabPaneProps, TabPane } from './components/TabPane'
import { TabPanesContentContainerStyled } from './styles/TabPanesContentContainerStyled'
import { TabPanesStyled } from './styles/TabPanesStyled'
import { TabPanesTabsContainerStyled } from './styles/TabPanesTabsContainerStyled'

export interface ITabPanesProps {
  activeKey: string
  onChange?(key: string): void
}

export const TabPanes = ({
  activeKey,
  onChange = noop,
  children,
}: PropsWithChildren<ITabPanesProps>) => {
  const Tabs = Children.map(children, (Pane) => {
    if (!isValidElement<ITabPaneProps>(Pane)) return undefined

    return (
      <Tab
        active={Pane.key === activeKey}
        onClick={() => onChange(Pane.key.toString())}
      >
        {Pane.props.label}
      </Tab>
    )
  })

  const Panes = Children.map(children, (Pane) => {
    if (!isValidElement<ITabPaneProps>(Pane)) return undefined

    return Pane.key === activeKey ? Pane : undefined
  })

  return (
    <TabPanesStyled>
      <TabPanesTabsContainerStyled>
        <Space direction='horizontal' size='xsmall'>
          {Tabs}
        </Space>
      </TabPanesTabsContainerStyled>
      <TabPanesContentContainerStyled>{Panes}</TabPanesContentContainerStyled>
    </TabPanesStyled>
  )
}

TabPanes.Pane = TabPane

TabPanes.displayName = 'TabPanes'
